module.exports = __webpack_public_path__ + "static/media/gold.0bd46124.webp";